import UserDropdown from "./UserDropdown";
import { Row, Col, Button } from "react-bootstrap";
import { useState, useReducer } from "react";
import { useEffect } from "react";

function ShareItem({
  item,
  items,
  users,
  toggleShare,
  updateItems,
  setShares,
  shares,
  forceUpdate,
  setAlert,
}) {
  const [user, setUser] = useState(null);

  useEffect(() => {}, [item, shares]);

  const findItem = (find) => {
    return find === item;
  };

  const inviteUser = () => {
    // Find index of current item in items for updating

    let i = items.findIndex(findItem);

    // Check to see if a user is set
    if (user == null || user?.value == null) {
      setAlert((prev) => ({
        ...prev,
        show: true,
        message: "Please select a user to share with.",
        isError: true,
      }));
      return;
    }
    // Check to see if the expiration date is GT current time
    if(items[i].latest_expiration_date && items[i].latest_expiration_date < (Date.now() / 1000) ){
      setAlert((prev) => ({
        ...prev,
        show: true,
        message: "This item has expired.",
        isError: true,
      }));
      return;
    }
    // Only invite user if the license count is right
    if (items[i].license_used >= items[i].license_count) {
      setAlert((prev) => ({
        ...prev,
        show: true,
        message: "You have no more licenses to share with this user.",
        isError: true,
      }));
      return;
    }
    

    document.body.style.cursor = "wait";

    let nonce = document.getElementById("_wpnonce").value;
    fetch("/wp-json/library/v1/share/" + user.value + "/" + item.id, {
      method: "post",
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "X-WP-Nonce": nonce, // here you used the wrong name
      },
    })
      .then((response) => response.json())
      .then((data) => {
        document.body.style.cursor = "default";
      
        if (!data.id) {
          setAlert((old) => ({
            ...old,
            show: true,
            message: data.response,
            isError: true,
          }));
          return;
        }

        items[i].license_used++;
        // find active item and change data there too
        let activeItems = items[i].active;

        let newShare = {
          id: data.id,
          share_user_email: user.label,
          progress: 0,
          share_user_id: user.value,
          pdf: false,
          expiry: data.expiry,
        };

        for (var activeItem in activeItems) {
          if (activeItems[activeItem].id == newShare.id) {
            activeItems[activeItem] = newShare;
          }
        }

        items.active = activeItems;

        updateItems(items);

        setShares((tempShares) => {
          tempShares.push(newShare);
          return tempShares;
        });

        setUser(null);

        forceUpdate();
      });
  };

  const buttonArrow = <div class="btn-arrow"></div>;

  return (
    <Row className="share-controls__row">
      <Col className="share-controls__field">
        <UserDropdown
          users={users}
          onChange={setUser}
          shares={shares}
          user={user}
        />
      </Col>
      <Col className="share-controls__button">
        <Button onClick={() => inviteUser()}>Share{buttonArrow}</Button>
      </Col>
    </Row>
  );
}

export default ShareItem;
